import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { ProjectId, UserId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { removeMembersFromProject } from 'data/projects/actions';
import { queryClient } from 'queries';
import { MEMBERS_V2_QUERY_KEY } from 'queries/members';
import { logger } from 'services';
import { remove } from 'stores/memberships';

interface Callback {
  (data: any): void;
}

function* removeMemberFromProjectSaga(
  action: PayloadAction<{
    projectId: number;
    members: {
      userId: number;
    }[];
    handleSuccess?: Callback;
    handleFailure?: Callback;
  }>,
) {
  const { payload } = action;
  const { projectId, members, handleSuccess, handleFailure } = payload;

  try {
    // TODO: no response on remove call, can use response once thats available @krishna
    yield ProjectAPI.removeMembers(projectId, members);

    if (handleSuccess) {
      handleSuccess(payload);
    }
    yield put(
      remove({
        projectId: ProjectId(projectId),
        userIds: payload.members.map(({ userId }) => UserId(userId)),
      }),
    );
    yield queryClient.invalidateQueries(MEMBERS_V2_QUERY_KEY);
  } catch (error) {
    logger.error('removeMembers failed', { error });
    if (handleFailure) {
      handleFailure(error);
    }
  }
}

export const watchRemoveMemberFromProjectSaga = function* (): Generator {
  yield takeLatest(removeMembersFromProject.type, removeMemberFromProjectSaga);
};
